import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'

const NavLeft = ({ page, setOpen }) => {

    useEffect(() => {
        let menu

        const init = () => {
            menu = document.querySelector('.menu-button')

            applyListeners()
        }

        const applyListeners = () => {
            menu.addEventListener('click', () => toggleClass('menu-button-active'))
        }

        const toggleClass = (stringClass) => {
            if (menu.classList.contains(stringClass)) {
                setOpen(false)
                menu.classList.remove(stringClass)
            } else {
                setOpen(true)
                menu.classList.add(stringClass)
            }
        }

        init()
        return () => { if (menu) menu.removeEventListener('click', applyListeners()) }
    }, [])

    return (
        <div className="nav-left">
            <div className="menu-button">
                <div className="menu-button-left"></div>
                <div className="menu-button-middle"></div>
                <div className="menu-button-right"></div>
            </div>
            <div className={`nav-location ${page ? 'nav-location-margin-top' : ''}`}>
                <Link className="nav-location-home" to="/">Home</Link> {page ? <div className="nav-location-page">-<span>{page}</span></div> : <div className="nav-location-page-home">-<span>Strona główna</span></div>}
            </div>
        </div>
    )
}

export { NavLeft }